import { SegmentedControl } from '@mantine/core';

export type ViewMode = 'ViewAll' | 'ViewAdvised' | 'ViewNonAdvised';

interface FilterRowProps {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export function FilterRow({ viewMode, setViewMode }: FilterRowProps) {
  return (
    <SegmentedControl
      value={viewMode}
      onChange={value => setViewMode(value as ViewMode)}
      data={[
        { label: 'View all', value: 'ViewAll' },
        { label: 'View advised', value: 'ViewAdvised' },
        { label: 'View non-advised', value: 'ViewNonAdvised' },
      ]}
    />
  );
}
